<template lang="pug">
.buffer-container
    BaseButton#buffer-button(
        type='primary',
        icon='el-icon-connection',
        @click='click'
    )
        | {{ $t('mensagens.menuMapa.labels.analisarProximidades') }}
</template>

<script>
import EventBus from '../../../utils/eventBus';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    components: {
        BaseButton
    },
    methods: {
        show(show) {
            show ? $('#buffer-button').show() : $('#buffer-button').hide();
        },
        click() {
            EventBus.$emit('mapa:buffer-click');
        }
    },
    created() {
        this.$bus.$off();

        this.$nextTick(function () {
            this.$bus.$on('mapa:show-buffer', this.show);
        });
    }
};
</script>

<style lang="scss">
#buffer-button {
    background: #19194b !important;
    width: auto !important;
    height: auto !important;
    color: var(--white);
    cursor: pointer;
    line-height: 20px;
    padding: 5px 10px !important;
    margin: 0 auto;
    display: none;
    i {
        margin-right: 0px;
        font-size: 15px;
    }
}
</style>
